export var ScopeSet;
(function (ScopeSet) {
    ScopeSet[ScopeSet["creatorPlus"] = 8] = "creatorPlus";
    ScopeSet[ScopeSet["default"] = 4] = "default";
    ScopeSet[ScopeSet["viewer"] = 5] = "viewer";
})(ScopeSet || (ScopeSet = {}));
